/* Bunivia funnel behaviour.
   Scripts 0, 1, 3 and 4 below are the reference prototype's own scripts,
   ported unchanged apart from the selectors Liquid generates. */
(function () {
  if (window.__bvFunnel) return; window.__bvFunnel = true;

  /* ═══════════════════════════════════════════════════════════════
     BUNIVIA scroll engine.

     One passive scroll listener, one rAF, no layout reads outside the
     frame. Sections opt in by carrying [data-bv-scroll]; the engine sets
     --bv-p on them: 0 when the section enters the viewport bottom, 1 when
     it leaves the top. CSS decides what that progress drives, so the JS
     stays generic and the motion stays on the compositor.

     Respect first: if the visitor prefers reduced motion, the engine
     never starts and every progress-driven style falls back to its
     resting state.
     ═══════════════════════════════════════════════════════════════ */
  function scrollEngine() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 900px)').matches) return;

    var els = [].slice.call(document.querySelectorAll('.bvf-page [data-bv-scroll], .bv-pdp[data-bv-scroll]'));

    /* the mechanism split opts in automatically */
    var mech = document.querySelector('.bvf-page .mech__split');
    if (mech && !mech.hasAttribute('data-bv-scroll')) {
      mech.setAttribute('data-bv-scroll', '');
      els.push(mech);
    }
    if (!els.length) return;

    var ticking = false;

    function frame() {
      ticking = false;
      var vh = window.innerHeight;

      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var total = r.height + vh;
        var p = (vh - r.top) / total;
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        el.style.setProperty('--bv-p', p.toFixed(4));

        /* mechanism: highlight the step nearest the viewport centre */
        if (el === mech) {
          var steps = el.querySelectorAll('.step');
          var mid = vh / 2, best = -1, bd = 1e9;
          [].forEach.call(steps, function (st, k) {
            var b = st.getBoundingClientRect();
            var d = Math.abs(b.top + b.height / 2 - mid);
            if (d < bd) { bd = d; best = k; }
          });
          [].forEach.call(steps, function (st, k) {
            st.classList.toggle('is-live', k === best);
          });
        }
      });
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  }
  scrollEngine();

  /* reveal on scroll — reference script 0.

     BUNIVIA: the reveal system existed but almost nothing carried .rev, so
     the page scrolled in with no motion at all. Rather than editing every
     section file, tag the moving parts automatically: each section's
     eyebrow, heading, lede, and its cards/steps/rows get the same
     rise-and-fade, staggered within their section. Elements already marked
     .rev keep their authored delays; prefers-reduced-motion still disables
     everything via the existing CSS. */
  function autoTag() {
    var SECT = '.bvf-page .sec, .bvf-page .life, .bvf-page .proof--chapter';
    var PARTS = [
      '.chap', 'h2', '.lede',
      '.step', '.cslide', '.vs__col', '.tw', '.rcard', '.arow',
      '.q', '.guar', '.gd__i', '.gd__shot', '.turn', '.plist > li',
      '.imgbox', '.vid', '.cmp', '.cmp__card', '.readout', '.hc'
    ].join(',');

    [].forEach.call(document.querySelectorAll(SECT), function (sec) {
      var i = 0;
      [].forEach.call(sec.querySelectorAll(PARTS), function (el) {
        if (el.closest('.carousel') && window.matchMedia('(max-width:899px)').matches) return; // rail manages its own motion on mobile
        if (!el.classList.contains('rev')) {
          el.classList.add('rev');
          var d = ['', 'd1', 'd2', 'd3'][Math.min(i, 3)];
          if (d) el.classList.add(d);
          i++;
        }
      });
    });
  }

  function reveal() {
    autoTag();
    var els = [].slice.call(document.querySelectorAll('.bvf-page .rev'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) {
        e.classList.add('in');
      });
      return;
    }

    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) {
          x.target.classList.add('in');
          io.unobserve(x.target);
        }
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    els.forEach(function (e, i) {
      var d = ['', 'd1', 'd2', 'd3'][i % 4];
      if (d && !/\bd[123]\b/.test(e.className)) e.classList.add(d);
      io.observe(e);
    });

    /* Safety net: copy must never stay invisible because an observer
       missed — but only rescue elements already inside the viewport.
       Revealing everything at once would spend every animation off-screen
       and the scroll would be flat again. Elements below the fold keep
       waiting for the observer, which is the whole point. */
    setTimeout(function () {
      var vh = window.innerHeight;
      els.forEach(function (e) {
        if (!e.classList.contains('in') && e.getBoundingClientRect().top < vh) {
          e.classList.add('in');
        }
      });
    }, 1200);
  }

  /* hotspots — reference script 1, plus the first marker open on load */
  function hotspots() {
    document.querySelectorAll('.bvf-page .htstage').forEach(function (w) {
      if (w.__bv) return;
      w.__bv = 1;

      var bs = w.querySelectorAll('.hp');
      var ps = w.querySelectorAll('.hpanel__body');

      function open(b) {
        bs.forEach(function (x) {
          x.setAttribute('aria-selected', 'false');
        });

        b.setAttribute('aria-selected', 'true');

        ps.forEach(function (p) {
          var on = p.getAttribute('data-p') === b.getAttribute('data-i');
          p.hidden = !on;

          if (on) {
            p.style.animation = 'none';
            void p.offsetWidth;
            p.style.animation = '';
          }
        });
      }

      bs.forEach(function (b) {
        b.addEventListener('click', function () {
          open(b);
        });
      });

      if (bs.length) open(bs[0]);
    });
  }

  /* UGC carousel — reference script 3, verbatim behaviour */
  function ugc() {
    var w = document.querySelector('.bvf-page .ucwrap');

    if (!w || w.__bv) return;
    w.__bv = 1;

    var t = w.querySelector('.uctrack');
    var real = [].slice.call(t.children);
    var n = real.length;
    var ds = [].slice.call(w.querySelectorAll('.ucdot'));

    if (n < 3) {
      real.forEach(function (c, k) {
        c.classList.toggle('is-on', k === 0);
      });
      return;
    }

    /* BUNIVIA: desktop renders this rail as a CSS grid, where clones become
       extra grid cells — the empty first column and the wrapped last card.
       So clones are only created at phone/tablet widths. */
    var bvDesktop = window.matchMedia('(min-width: 900px)').matches;

    if (!bvDesktop) {
      real.slice(-2).forEach(function (el) {
        t.insertBefore(el.cloneNode(true), t.firstChild);
      });

      real.slice(0, 2).forEach(function (el) {
        t.appendChild(el.cloneNode(true));
      });
    }

    var cards = [].slice.call(t.children);
    var i = bvDesktop ? 0 : 4;
    var anim = true;

    function place() {
      var el = cards[i];

      t.style.transition = anim
        ? 'transform .55s cubic-bezier(.2,.7,.3,1)'
        : 'none';

      t.style.transform =
        'translateX(' +
        (t.clientWidth / 2 - el.offsetLeft - el.offsetWidth / 2) +
        'px)';

      cards.forEach(function (c, k) {
        c.classList.toggle('is-on', k === i);
      });

      var r = ((i - 2) % n + n) % n;

      ds.forEach(function (d, k) {
        d.classList.toggle('on', k === r);
      });
    }

    function go(d) {
      i += d;
      anim = true;
      place();
    }

    t.addEventListener('transitionend', function () {
      if (i >= n + 2) {
        anim = false;
        i -= n;
        place();
      } else if (i < 2) {
        anim = false;
        i += n;
        place();
      }
    });

    w.querySelectorAll('.ucnav').forEach(function (b) {
      b.addEventListener('click', function () {
        go(+b.getAttribute('data-dir'));
      });
    });

    ds.forEach(function (d) {
      d.addEventListener('click', function () {
        i = (+d.getAttribute('data-i')) + 2;
        anim = true;
        place();
      });
    });

    cards.forEach(function (c, k) {
      c.addEventListener('click', function () {
        i = k;
        anim = true;
        place();
      });
    });

    place();

    window.addEventListener('resize', function () {
      anim = false;
      place();
    });
  }

  /* comfort carousel — reference script 4 (desktop) and the mobile reference
     script, chosen at the 820px breakpoint the CSS uses. */
  function carouselDesktop(r, signal) {
    var cards = [].slice.call(r.querySelectorAll('.cslide'));
    var dots = [].slice.call(
      document.querySelectorAll('.bvf-page .cdots i')
    );

    function sync() {
      var mid = r.scrollLeft + r.clientWidth / 2;
      var best = 0;
      var d = 1e9;

      cards.forEach(function (c, k) {
        var cc = c.offsetLeft + c.offsetWidth / 2;
        var dist = Math.abs(cc - mid);

        if (dist < d) {
          d = dist;
          best = k;
        }
      });

      cards.forEach(function (c, k) {
        c.classList.toggle('is-mid', k === best);
      });

      dots.forEach(function (x, k) {
        x.classList.toggle('on', k === best);
      });
    }

    r.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(sync);
      },
      {
        passive: true,
        signal: signal
      }
    );

    dots.forEach(function (x, k) {
      x.style.cursor = 'pointer';

      x.addEventListener(
        'click',
        function () {
          var c = cards[k];

          r.scrollTo({
            left: c.offsetLeft - (r.clientWidth - c.offsetWidth) / 2,
            behavior: 'smooth'
          });
        },
        {
          signal: signal
        }
      );
    });

    sync();

    window.addEventListener('resize', sync, {
      signal: signal
    });
  }

  function carouselMobile(r, signal) {
    var real = [].slice.call(r.querySelectorAll('.cslide'));
    var n = real.length;
    var dots = [].slice.call(
      document.querySelectorAll('.bvf-page .cdots i')
    );

    if (!n) return;

    var bvDesktop2 = window.matchMedia('(min-width: 900px)').matches;

    if (!bvDesktop2) {
      var a = real[n - 1].cloneNode(true);
      var b = real[0].cloneNode(true);

      a.dataset.c = 1;
      b.dataset.c = 1;

      /* Boundary clones only: eager + sync decode, so the seam card is
         already painted when the rebase lands on it. Every other image in
         the rail keeps loading="lazy". */
      [a, b].forEach(function (cl) {
        [].forEach.call(cl.querySelectorAll('img'), function (img) {
          img.loading = 'eager';
          img.decoding = 'sync';
          if (img.dataset && img.dataset.src) { img.src = img.dataset.src; }
        });
      });

      r.insertBefore(a, r.firstChild);
      r.appendChild(b);
    }

    var cards = [].slice.call(r.querySelectorAll('.cslide'));
    var lock = false;

    function centre(el, smooth) {
      lock = true;

      var target = el.offsetLeft - (r.clientWidth - el.offsetWidth) / 2;

      if (smooth) {
        r.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(function () { lock = false; }, 280);
        return;
      }

      /* BUNIVIA: the invisible rebase.

         Frame-by-frame analysis of the recording showed the centred card
         fading to near-invisible over ~0.3s and snapping back. That fade is
         the .cslide opacity transition (.38s): during the rebase window the
         clone loses is-mid while still the visible card, so the browser
         animates it from 1 to .55 in front of the customer, and the real
         card then lands at full strength.

         The cure is to make the swap atomic: freeze every card transition,
         suspend snap, jump, immediately hand is-mid to the destination card,
         force one reflow so all of it commits in the same paint, then
         restore transitions on the following frame. Between those two
         frames the clone and the real card are pixel-identical, so there is
         nothing to see. */
      var snap = r.style.scrollSnapType;

      r.classList.add('bv-rebase');
      r.style.scrollSnapType = 'none';
      r.scrollLeft = target;

      cards.forEach(function (c) {
        c.classList.toggle('is-mid', c === el);
      });

      void r.offsetWidth;
      r.style.scrollSnapType = snap || '';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          r.classList.remove('bv-rebase');
        });
      });

      lock = false;
    }

    function nearest() {
      var m = r.scrollLeft + r.clientWidth / 2;
      var bi = 0;
      var bd = 1e9;

      cards.forEach(function (c, k) {
        var d = Math.abs(
          c.offsetLeft + c.offsetWidth / 2 - m
        );

        if (d < bd) {
          bd = d;
          bi = k;
        }
      });

      return bi;
    }

    function sync() {
      var i = nearest();

      cards.forEach(function (c, k) {
        c.classList.toggle('is-mid', k === i);
      });

      var ri = (i - 1 + n) % n;

      dots.forEach(function (d, k) {
        d.classList.toggle('on', k === ri);
      });

      if (!lock && !bvDesktop2) {
        if (i === 0) {
          centre(cards[bvDesktop2 ? n - 1 : n], false);
        } else if (i === cards.length - 1) {
          centre(cards[1], false);
        }
      }
    }

    var t;
    var hasScrollEnd = 'onscrollend' in window;
    var restRaf, restLast = -1, restStill = 0, touching = false;

    /* Considered at rest once scrollLeft has held the same value for three
       frames and no finger is down. Costs nothing: it only runs while the
       carousel is actually moving. */
    function restWatch() {
      if (restRaf) cancelAnimationFrame(restRaf);
      restLast = -1;
      restStill = 0;

      (function tick() {
        var x = Math.round(r.scrollLeft);
        if (x === restLast) { restStill++; } else { restStill = 0; restLast = x; }

        if (restStill >= 3 && !touching) {
          restRaf = null;
          sync();
          return;
        }
        restRaf = requestAnimationFrame(tick);
      })();
    }

    ['touchstart', 'pointerdown'].forEach(function (ev) {
      r.addEventListener(ev, function () { touching = true; }, { passive: true, signal: signal });
    });
    ['touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (ev) {
      r.addEventListener(ev, function () { touching = false; }, { passive: true, signal: signal });
    });

    /* BUNIVIA: scrollend fires the moment momentum stops, so the loop jump
       happens with no visible pause. The timeout below stays as a fallback. */
    if (hasScrollEnd) {
      r.addEventListener('scrollend', function () {
        clearTimeout(t);
        if (restRaf) { cancelAnimationFrame(restRaf); restRaf = null; }
        if (!touching) sync();
      }, { signal: signal });
    }

    r.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(function () {
          var i = nearest();

          cards.forEach(function (c, k) {
            c.classList.toggle('is-mid', k === i);
          });

          var ri = (i - 1 + n) % n;

          dots.forEach(function (d, k) {
            d.classList.toggle('on', k === ri);
          });
        });

        clearTimeout(t);
        /* BUNIVIA: a timer is the wrong tool on iOS. Momentum can run for a
           second or more after the finger leaves, and Safari only shipped
           scrollend in version 18 — so on anything older the jump fired while
           the track was still moving, and the two fought. Instead of guessing
           a delay, watch scrollLeft until it stops changing. */
        restWatch();
      },
      {
        passive: true,
        signal: signal
      }
    );

    dots.forEach(function (d, k) {
      d.style.cursor = 'pointer';

      d.addEventListener(
        'click',
        function () {
          centre(cards[bvDesktop2 ? k : k + 1], true);
        },
        {
          signal: signal
        }
      );
    });

    requestAnimationFrame(function () {
      centre(cards[bvDesktop2 ? 0 : 1], false);
      sync();
    });

    window.addEventListener(
      'resize',
      function () {
        centre(cards[nearest()], false);
      },
      {
        signal: signal
      }
    );
  }

  function carousel() {
    var r = document.querySelector('.bvf-page .carousel');

    if (!r) return;

    var mq = window.matchMedia('(min-width: 820px)');
    var mode = null;
    var ctl = null;

    function teardown() {
      if (!ctl) return;

      ctl.abort();

      [].slice.call(
        r.querySelectorAll('.cslide[data-c]')
      ).forEach(function (c) {
        c.remove();
      });

      [].slice.call(
        r.querySelectorAll('.cslide')
      ).forEach(function (c) {
        c.classList.remove('is-mid');
      });

      [].slice.call(
        document.querySelectorAll('.bvf-page .cdots i')
      ).forEach(function (d) {
        d.classList.remove('on');
      });

      ctl = null;
    }

    function build() {
      var want = mq.matches ? 'desktop' : 'mobile';

      if (want === mode) return;

      teardown();

      ctl = new AbortController();
      mode = want;

      if (want === 'desktop') {
        carouselDesktop(r, ctl.signal);
      } else {
        carouselMobile(r, ctl.signal);
      }
    }

    build();

    if (mq.addEventListener) {
      mq.addEventListener('change', build);
    } else {
      mq.addListener(build);
    }
  }

  /* sticky ATC hide — reference script 2 */
  function stickyHide() {
    var bar = document.querySelector(
      '.sticky, .bv-sticky, [data-bv-sticky]'
    );

    var end = document.getElementById('bv-final-cta');

    if (!bar || !end || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      function (e) {
        bar.classList.toggle(
          'is-hidden',
          e[0].isIntersecting
        );
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -10% 0px'
      }
    ).observe(end);
  }

  /* footer columns: mobile reference ships <details> (closed accordion),
     desktop reference ships <details open>. Synced at the 820px breakpoint. */
  function footer() {
    var accs = [].slice.call(
      document.querySelectorAll('.bvf-page .ft__col details')
    );

    if (!accs.length) return;

    var mq = window.matchMedia('(min-width: 820px)');

    function sync() {
      accs.forEach(function (d) {
        d.open = mq.matches;
      });
    }

    sync();

    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else {
      mq.addListener(sync);
    }
  }

  function init() {
    reveal();
    hotspots();
    ugc();
    carousel();
    stickyHide();
    footer();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  }

  document.addEventListener(
    'shopify:section:load',
    function () {
      init();
    }
  );
})();